<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">Sana Ait Emailini Düzenle</h4>
              <p class="card-category">Müşterilerine gönderilen mailler bu mail ile gönderilecektir. Şifre güncellersen, buradan da güncellemen gerekir.</p>
            </template>


            <form class="m-5">
              <div class="row">
                <div class="col-md-4">
                  <base-input type="email" label="Email" placeholder="Email" v-model="payload.mail">
                  </base-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <base-input type="number" label="Port" placeholder="Port" v-model="payload.port">
                  </base-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <base-input type="text" label="Host" placeholder="Host" v-model="payload.host">
                  </base-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <base-input type="text" label="password" placeholder="password" v-model="payload.password">
                  </base-input>
                </div>
              </div>
             
              <div class="row">
                <div class="col-md-4">
                  <base-input type="text" label="İsim Soyisim" placeholder="İsim Soyisim" v-model="payload.name">
                  </base-input>
                </div>
              </div>
             
              <div class="row">
                <div class="col-md-4">
                  <base-input type="text" label="Pozisyon" placeholder="Pozisyon" v-model="payload.companyRole">
                  </base-input>
                </div>
              </div>
            
              <div class="row">
                <div class="col-md-4">
                  <base-input type="text" label="Mobil Telefon Numarası" placeholder="Mobil Telefon Numarası" v-model="payload.mobile">
                  </base-input>
                </div>
              </div>




              <div class="text-center">
                <button type="submit" class="btn btn-info btn-fill float-right" @click="updateMail()">
                  Güncelle
                </button>
              </div>
              <div class="clearfix"></div>
            </form>

          </card>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Card from 'src/components/Cards/Card.vue'
  import CollectionService from "../../services/collection.service.js";
  export default {
    components: {
      Card
    },
    data() {
      return {
        id: null,
        payload: {
        }
      }
    },
    mounted() {
      this.id = window.location.href.split('/').at(-1);
      this.getFromMail();
    },
    methods: {
      updateMail() {
        CollectionService.updateCollectionItem('frommail', this.id, this.payload).then((res) => {
          if (res.success == true) {
            this.notifyVue('bottom', 'right', 'success', "Mail Güncellendi")
            this.$router.push(`/admin/frommails`);
          } else {
            this.notifyVue('bottom', 'right', 'danger', res.body)
          }
        }).catch(err => {
          this.notifyVue('bottom', 'right', 'danger', err)
        })
      },
      getFromMail() {
       
        CollectionService.getCollectionItemWithId('frommail', this.id).then((res) => {
          if (res.success == true) {
            console.log(res.f)
            this.payload = res.fromMail;
            console.log(this.payload)
          } else {
            console.log('error');
          }
        })
      },
      notifyVue(verticalAlign, horizontalAlign, type, message) {
        this.$notifications.notify(
          {
            message: JSON.stringify(message),
            icon: '',
            horizontalAlign: horizontalAlign,
            verticalAlign: verticalAlign,
            type
          })
      }
    }
  }
</script>
<style>
</style>